module.exports = __webpack_public_path__ + "static/media/bg-4.7a9f77fa.jpg";